import React, { useEffect, useState } from "react";

//Assets
import "~/assets/sass/pages/mypage/admin/business.scss";
import "~/assets/sass/pages/mypage/admin/business/uncertified.scss";
import "~/assets/sass/pages/mypage/admin/business/certified.scss";
import "~/assets/sass/pages/mypage/admin/business/processing.scss";
import { Case, If } from "~/common/components/If";
import Uncertified from "./contents/Uncertified";
import Complete from "./contents/Complete";


const BusinessAuth = ({ edit, setCertImg, info }) => {


	const [bsnList, setBsnList] = useState(info.certificate ?? null);



	const [step, setStep] = useState("uncertified");




	useEffect(() => {
		const curStep =
			info.certificate === null ? "uncertified" : "done";
		console.log(bsnList)
		setStep(curStep);
	}, [info.certificate]);





	return (
		<div className="p__admin-business business-auth-wrapper">
			<h3 className="section-title">사업자인증</h3>

			<If condition={step} {...{ setStep, info, edit, setCertImg }}>
				<Case condition="uncertified">
					{/*-----미인증-----*/}
					<Uncertified setCertImg={setCertImg} />
				</Case>

				{/* 				
				<Case condition="processing">
					
					<Complete {...{ imageDone }} />
				</Case>
				 */}
				{/*-----심사중-----*/}
				{/* <Processing /> */}

				<Case condition="done">
					{/*-----인증-----*/}
					<Complete
						setCertImg={setCertImg}
					/>
				</Case>
			</If>
		</div >
	);
};
export default BusinessAuth;
